// extracted by mini-css-extract-plugin
export default {"container":"Onboarding_container__x8tTG","intro":"Onboarding_intro__J1-Lt"};